import { VehiculeCheckProgressStatus } from '@/api/entities/vehicule-check';
import { TFunction } from 'i18next';

interface IVehiculeCheckProgressLabel {
  t: TFunction<undefined>;
  status: VehiculeCheckProgressStatus;
}

export const getInspectionProgressStatusLabel = ({
  t,
  status,
}: IVehiculeCheckProgressLabel) => {
  if (status === VehiculeCheckProgressStatus.IN_PROGRESS) {
    return t('inspectionInProgress');
  }

  if (status === VehiculeCheckProgressStatus.REQUEST_CREATED) {
    return t('requestCreated');
  }

  if (status === VehiculeCheckProgressStatus.REQUEST_CREATED_AND_SENT) {
    return t('requestCreatedAndSent');
  }

  if (
    status === VehiculeCheckProgressStatus.COMPLETED ||
    status === VehiculeCheckProgressStatus.COMPLETED_STILL_WAITING_FOR_VIDEO ||
    status === VehiculeCheckProgressStatus.COMPLETED_STILL_WAITING_FOR_CHUNKS ||
    status === VehiculeCheckProgressStatus.COMPLETED_STILL_PROCESSING_VIDEO ||
    status === VehiculeCheckProgressStatus.COMPLETED_REPORT_AVAILABLE
  ) {
    return t('inspectionCompleted');
  }
  return null;
};

export const getInspectionSubProgressStatus = ({
  t,
  status,
}: IVehiculeCheckProgressLabel) => {
  if (
    status === VehiculeCheckProgressStatus.COMPLETED_STILL_WAITING_FOR_VIDEO ||
    status === VehiculeCheckProgressStatus.COMPLETED_STILL_WAITING_FOR_CHUNKS
  ) {
    return {
      text: t('receiptInProgress'),
      className: 'text-purple-E000FF/60',
    };
  }

  if (status === VehiculeCheckProgressStatus.COMPLETED_STILL_PROCESSING_VIDEO) {
    return {
      text: t('processInProgress'),
      className: 'text-blue-20BDFF',
    };
  }

  if (status === VehiculeCheckProgressStatus.COMPLETED_REPORT_AVAILABLE) {
    return {
      text: t('reportAvailable'),
      className: 'text-green-11BFA4',
    };
  }

  return null;
};
